import { FaultStatus } from '@customer/store/apis/assetsApi';
import { setFaultStatus } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import SingleSelectFilter from './SingleSelectFilter';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useFaultStatusOptions = (): DropdownItemProps<FaultStatus>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.keys(FaultStatus).map((key: string) => {
      const value = FaultStatus[key as keyof typeof FaultStatus];
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`filters.FaultStatus.${key}`),
      };
    });
  }, [t]);
};

export const FaultStatusFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilter<FaultStatus>
      filterName="faultStatus"
      label={label ?? t('FaultTestStatus')}
      elementRef={elementRef}
      action={setFaultStatus}
      useItemsHook={useFaultStatusOptions}
    />
  );
};

export default FaultStatusFilter;
